module.exports = __webpack_public_path__ + "img/HOS-Missing3.68cef789.png";